import { axiosClient } from "@/api/axios";

export async function postLesson(payload) {
  return axiosClient.post("import/lesson", payload);
}
